import { useState, useEffect } from "react"
import axios from "axios"
import "./PublicLessonsReservation.css"
import {useAuth} from "../context/AuthContext"
import { FaX } from "react-icons/fa6";
import {
  format,
  startOfWeek,
  addDays,
  isSameDay,
  parseISO,
  addWeeks,
  subWeeks
} from "date-fns"
import csLocale from "date-fns/locale/cs"
import { useParams } from "react-router-dom"

const PublicLessonsReservation = () => {
  const [message, setMessage] = useState({});
    const businessId = useParams()
    const {user, quest, businessToken} = useAuth()
    const [detailOverlay, setDetailOverlay] = useState(false)
    const [selectedLesson, setSelectedLesson] = useState(null)
  const [lessonInstances, setLessonInstances] = useState([])
  const [currentWeekStart, setCurrentWeekStart] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }))
  const [editOverlay, setEditOverlay] = useState(false)
  const [selectedLessonName, setSelectedLessonName] = useState("")
  const [sending, setSending] = useState(false)
  const [lessonToEdit, setLessonToEdit] = useState({
    otherInstructor: '',
    date: '',
    time: '',
    place: ''
  });

const openEditorOverlay = (lesson) => {
  setLessonToEdit(lesson)
  setEditOverlay(true)
}

const closeEditorOverlay = () => {
  setEditOverlay(false)
  setLessonToEdit(null)
}
 
  useEffect(() => {
    const fetchLessons = async () => {
        
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/lessons/get-instances`, {
          params: { businessId: businessId.businessId }
        })
        setLessonInstances(res.data)

      } catch (err) {
        console.error("Chyba při načítání lekcí:", err)
      }
    }

    if (businessId) fetchLessons()

  }, [businessId])

  const fetchNewLessons = async () => {
        
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/lessons/get-instances`, {
        params: { businessId: businessId.businessId }
      })
      setLessonInstances(res.data)
    } catch (err) {
      console.error("Chyba při načítání lekcí:", err)
    }
  }

  const getWeekDays = () => {
    return [...Array(7)].map((_, i) => addDays(currentWeekStart, i))
  }

  const handlePrevWeek = () => {
    setCurrentWeekStart((prev) => subWeeks(prev, 1))
  }

  const handleNextWeek = () => {
    setCurrentWeekStart((prev) => addWeeks(prev, 1))
  }

  const openDetailOverlay = (lesson) => {

    setSelectedLesson(lesson)
    setDetailOverlay(true)
  }
  const closeDetailOverlay = () => {
    setDetailOverlay(false)
    setSelectedLesson(null)
  }

  const availablePosition = (users, capacity) => {
    if (!capacity) return "Nezadáno"
    return capacity - users.length
  }

  const handleSubmit = async (id) => {

    if (user) {
      const userData = user
      try {
        setSending((prev) => ({
          ...prev,
          [id]: true,
        }))
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/lessons/invite`, {
          userData,
          id
        })
        setMessage(prev => ({
          ...prev,
          [id]: response.data.message || "Odesláno"
        }))
      } catch (err) {
        setMessage(prev => ({
          ...prev,
          [id]: err.response?.data?.message || "Chyba při odeslání"
        }))
      } finally {
        setSending((prev) => ({
          ...prev,
          [id]: false,
        }))
        setTimeout(() => {
          setMessage({})
        }, 2000)
        setTimeout(() => {
          fetchNewLessons()
        }, 3000)
      }
    }
    if (quest) {
      const userData = quest
      try {
        setSending((prev) => ({
          ...prev,
          [id]: true,
        }))
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/lessons/invite`, {
          userData,
          id
        })
        setMessage(prev => ({
          ...prev,
          [id]: response.data.message || "Odesláno"
        }))
      } catch (err) {
        setMessage(prev => ({
          ...prev,
          [id]: err.response?.data?.message || "Chyba při odeslání"
        }))
      } finally {
        setSending((prev) => ({
          ...prev,
          [id]: false,
        }))
        setTimeout(() => {
          setMessage({})
        }, 2000)
        setTimeout(() => {
          fetchNewLessons()
        }, 3000)
      }
    }
  }


  const handleDeleteInstance = async (id) => {
    if (businessToken) {
      try {
        const instanceId = id
  
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/lessons/delete-instance`,
          {
            params: {instanceId} ,
            headers: {
              Authorization: `Bearer ${businessToken}`,
            },
          }
        );
  
  
        setMessage(prev => ({
          ...prev,
          [id]: response.data?.message || "Smazáno"
        }))
      } catch (err) {
        setMessage(prev => ({
          ...prev,
          [id]: err.response?.data?.message || "Chyba při odeslání"
        }))
      } finally {
        setTimeout(() => {
          setMessage({});
          fetchNewLessons();
        }, 2000);
        setTimeout(() => {
          fetchNewLessons()
        }, 2500)
      }
    }
  };
  const handleEditorSubmit = async (e, id) => {
    e.preventDefault();
  
    if (businessToken) {
      try {
        const instanceId = id;
  
        // Odesílání dat ve formátu
        const response = await axios.put(`${process.env.REACT_APP_API_URL}/lessons/update-instance`,
          { 
            instanceId,
            date: lessonToEdit.date, 
            time: lessonToEdit.time, 
            place: lessonToEdit.place,  
            instructor: lessonToEdit.otherInstructor 
          },
          { headers: { Authorization: `Bearer ${businessToken}` } }
        );
  
        setMessage(prev => ({
          ...prev,
          [id]: response.data.message || "Lekce úspěšně upravena"
        }));
      } catch (err) {
        setMessage(prev => ({
          ...prev,
          [id]: err.response?.data?.message || "Chyba při úpravě"
        }));
      } finally {
        setTimeout(() => {
          setMessage({})
          closeEditorOverlay();
          fetchNewLessons()
        }, 2000)
      }
    }
  };

  return (
    <div className="calendar-conteiner">
      <h2 className="services-title">Skupinové aktivity</h2>
<div className="calendar-header">
<div className="lesson-buttons-header">
  <button className="lesson-button" onClick={handlePrevWeek}>Předchozí týden</button>
  <span className="calendar-week-range visible-range">
    {format(currentWeekStart, "dd.MM.yyyy")} – {format(addDays(currentWeekStart, 6), "dd.MM.yyyy")}
  </span>
  <button className="lesson-button" onClick={handleNextWeek}>Následující týden</button>
</div>
<span className="calendar-week-range non-visible-range">
    {format(currentWeekStart, "dd.MM.yyyy")} – {format(addDays(currentWeekStart, 6), "dd.MM.yyyy")}
  </span>

</div>
<div>
  <select
    className='basic-input reservation-select lesson-select'
    value={selectedLessonName}
    onChange={(e) => setSelectedLessonName(e.target.value)}
  >
    <option value="">Všechny lekce</option>
    {[...new Set(lessonInstances.map((lesson) => lesson.template?.name))]
      .filter(Boolean)
      .sort()
      .map((name) => (
        <option key={name} value={name}>
          {name}
        </option>
      ))}
  </select>
</div>


      <div className="calendar">
        {getWeekDays().map((day) => {
          const lessonsForDay = lessonInstances.filter((lesson) =>
            isSameDay(parseISO(lesson.date), day) && 
          (selectedLessonName === "" || lesson.template?.name === selectedLessonName)
          )




          return (
            <div key={day.toISOString()}>
            <div className="calendar-day">
              <h3>{format(day, "EEEE dd.MM", { locale: csLocale })}</h3>
              {lessonsForDay.length > 0 ? (
                lessonsForDay.map((lesson) => (
                  <div key={lesson?._id} className={`lesson ${lesson.status === "open" ? "open-lesson" : "not-open-lesson"}`}>
                    <h2>{lesson.template?.name}</h2>
                    <div className="lesson-calendar-span"><h5>Zahájení:</h5><p> {lesson?.time}</p></div>
                    <div className="lesson-calendar-span"><h5>Volná místa:</h5><p>  {availablePosition(lesson.users, lesson.template?.capacity)}</p></div>
                    <div className="lesson-calendar-span"><h5>Cena:</h5><p>  {lesson.template?.cost} Kč</p></div>
                    {lesson.users?.length >= lesson.template?.capacity ? (<div className="lesson-center-buttons">
                      <h2>Plně obsazeno</h2>
                    </div>) : (<div>
                      {!message[lesson._id] && <div className="lesson-center-buttons">
                      <button className="lesson-button"  onClick={() => handleSubmit(lesson._id)}>{sending ? "Přidávám..." : "Zúčastnit se"}</button>
                      <button className="lesson-button"  onClick={() => openDetailOverlay(lesson)}>Detail</button>
                      </div>}
                    </div>)}
                    {businessToken && <div className="lesson-row-buttons">
                      <button className="lesson-button" onClick={() => openEditorOverlay(lesson)}>Upravit</button>
                      <button className="lesson-button" onClick={() => handleDeleteInstance(lesson?._id)}>Smazat</button>                   
                      </div>}
                    {message[lesson._id] && <p className="message">{message[lesson._id]}</p>}
                  </div>
                ))
              ) : (
                <div></div>
              )}
            </div>
          </div>)
        })}
      </div>
      {detailOverlay && selectedLesson && (
  <div className="lesson-overlay">
    <div className="lesson-overlay-content">
      <button onClick={closeDetailOverlay} className="lesson-close-button"><FaX /></button>
      <h2 className="lesson-calendar-name-overlay">{selectedLesson?.template?.name}</h2>
      <div className="lesson-calendar-span-overlay"><h5>Instruktor:</h5><p>{selectedLesson?.otherInstructor || selectedLesson.template?.instructor}</p></div>
      <div className="lesson-calendar-span-overlay"><h5>Datum:</h5><p> {format(parseISO(selectedLesson?.date), "dd.MM.yyyy", { locale: csLocale })}</p></div>
      <div className="lesson-calendar-span-overlay"><h5>Zahájení:</h5><p> {selectedLesson?.time}</p></div>
      <div className="lesson-calendar-span-overlay"><h5>Kapacita:</h5><p> {selectedLesson?.template?.capacity}</p></div>
      <div className="lesson-calendar-span-overlay"><h5>Volná místa:</h5><p> {availablePosition(selectedLesson.users, selectedLesson.template?.capacity)}</p></div>
      <div className="lesson-calendar-span-overlay"><h5>Cena:</h5><p> {selectedLesson?.template?.cost} Kč</p></div>
      <div className="lesson-calendar-span-overlay"><h5>Trvání lekce:</h5><p> {selectedLesson?.template?.duration} minut</p></div>
      <div className="lesson-center-buttons lesson-margin-top">
        <button className="lesson-button " onClick={() => handleSubmit(selectedLesson?._id)}>{sending ? "Přidávám..." : "Zúčastnit se"}</button>
      </div>
      {selectedLesson?._id && message[selectedLesson._id] && (
        <p className="message">{message[selectedLesson._id]}</p>
      )}
      {/* můžeš přidat další informace */}
    </div>
  </div>
)}
{editOverlay && lessonToEdit && (
  <div className="lesson-overlay">
    <div className="lesson-overlay-content">
      <button onClick={closeEditorOverlay} className="lesson-close-button"><FaX /></button>
      <h2 className="lesson-calendar-name-overlay">Upravit lekci</h2>

      <form onSubmit={(e) => handleEditorSubmit(e, lessonToEdit._id)}>
        <div className="lesson-calendar-span-overlay">
          <h5>Instruktor:</h5>
          <input 
           className='basic-input hotel-input'
            type="text" 
            id="instructor" 
            value={lessonToEdit.otherInstructor || lessonToEdit.template?.instructor} 
            onChange={(e) => setLessonToEdit({...lessonToEdit, otherInstructor: e.target.value})}
          />
        </div>

        <div className="lesson-calendar-span-overlay">
          <h5>Datum:</h5>
          <input 
           className='basic-input hotel-input'
            type="date" 
            id="date" 
            value={lessonToEdit.date ? format(new Date(lessonToEdit.date), 'yyyy-MM-dd') : ''}
            onChange={(e) => setLessonToEdit({...lessonToEdit, date: e.target.value})}
          />
        </div>

        <div className="lesson-calendar-span-overlay">
          <h5>Čas:</h5>
          <input 
           className='basic-input hotel-input'
            type="time" 
            id="time" 
            value={lessonToEdit.time} 
            onChange={(e) => setLessonToEdit({...lessonToEdit, time: e.target.value})}
          />
        </div>

        <div className="lesson-calendar-span-overlay">
          <h5>Místo:</h5>
          <input 
           className='basic-input hotel-input'
            type="text" 
            id="place" 
            value={lessonToEdit.place} 
            onChange={(e) => setLessonToEdit({...lessonToEdit, place: e.target.value})}
          />
        </div>

        {/* Zobrazení chybové zprávy */}
        {message[lessonToEdit._id] && (
          <div className="message">{message[lessonToEdit._id]}</div>
        )}

        <div className="lesson-center-buttons lesson-margin-top">
          <button className="lesson-button" type="submit">Uložit změny</button>
        </div>
      </form>
    </div>
  </div>
)}
    </div>
  )
}

export default PublicLessonsReservation